import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-signout',
    templateUrl: './signout.component.html',
    styleUrls: ['./signout.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class SignoutComponent implements OnInit {
    constructor(private readonly _auth: AuthService) {}

    ngOnInit(): void {
        this._auth.signOut();
    }
}
